import bootstrapcss  from '../node_modules/bootstrap/dist/css/bootstrap.css'
import bootstrapjs  from '../node_modules/bootstrap/dist/js/bootstrap.js'
export default {bootstrapcss, bootstrapjs};